import React from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import GenericButton from './GenericButton';
import { PRIMARY_COLOR } from '../constants/colors';
import { MEMBER_DISCOUNT_PERCENT } from '../constants/memberCampaign';

const PromoContent = styled.div`
  text-align: center;
  padding: 1.5rem 0.5rem 0.5rem 0.5rem;
`;
const PromoTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: ${PRIMARY_COLOR};
`;
const PromoText = styled.p`
  font-size: 1.1rem;
  margin-bottom: 2rem;
`;

const GuestPromoModal = ({ isOpen, onClose, onAgree }) => (
  <Modal isOpen={isOpen} onClose={onClose} showCloseButton={false}>
    <PromoContent>
      <PromoTitle>%{MEMBER_DISCOUNT_PERCENT} Üye İndirimi!</PromoTitle>
      <PromoText>
        Şimdi kayıt olursanız tüm siparişlerinizde <b>%{MEMBER_DISCOUNT_PERCENT} indirim</b> kazanacaksınız.<br/>
        Hemen kayıt olup fırsatı kaçırmayın!
      </PromoText>
      <GenericButton
        $background={PRIMARY_COLOR}
        $color="#fff"
        $hoverBackground={PRIMARY_COLOR}
        $hoverColor="#fff"
        $fontSize="1.15rem"
        $maxWidth="220px"
        onClick={onAgree}
        style={{marginBottom: 12}}
      >
        Kayıt Ol
      </GenericButton>
      <div>
        <button style={{background:'none',border:'none',color:'#888',marginTop:8,cursor:'pointer',fontSize:'1rem'}} onClick={onClose}>Daha Sonra</button>
      </div>
    </PromoContent>
  </Modal>
);

export default GuestPromoModal;
